export function getDirFromFilePath(path: string) {
  return path.substring(0, path.lastIndexOf('/'));
}
